export const ChatsTypes = {
    CHAT_NEW_MESSAGE : 'CHAT_NEW_MESSAGE_CHAT',
    CHAT_TYPING_MESSAGE : 'CHAT_TYPING_MESSAGE_CHAT',
    CHAT_STOPTYPING_MESSAGE : 'CHAT_STOPTYPING_MESSAGE_CHAT',
    RESET : 'RESET',
};